import { navFolderSlot } from "@/lib/mail/folderNavSections";
import { countUnreadInFolderSnapshot } from "@/lib/mail/folderSnapshotUnread";
import { syncFolderHeaders } from "@/lib/mail/folderWarmup";
import type { MailFolder } from "@/lib/types/mail";

export function resolveInboxFolder(folders: MailFolder[]): MailFolder | undefined {
  return folders.find((folder) => navFolderSlot(folder.name, folder.label) === "inbox");
}

/** Pastille IMAP > snapshot local → nouveaux mails pas encore dans la liste. */
export function isInboxBadgeAheadOfSnapshot(accountId: number, folders: MailFolder[]): boolean {
  const inbox = resolveInboxFolder(folders);
  if (!inbox) return false;
  const badgeUnread = inbox.unread ?? 0;
  if (badgeUnread <= 0) return false;
  const snapshotUnread = countUnreadInFolderSnapshot(accountId, inbox.name);
  return badgeUnread > snapshotUnread;
}

/** Rattrape les en-têtes INBOX quand la pastille IMAP dépasse le snapshot affiché. */
export async function syncInboxHeadersIfBadgeAhead(
  accountId: number,
  folders: MailFolder[]
): Promise<boolean> {
  const inbox = resolveInboxFolder(folders);
  if (!inbox || !isInboxBadgeAheadOfSnapshot(accountId, folders)) return false;
  await syncFolderHeaders(accountId, inbox.name);
  return true;
}
